import React, { useEffect, useState } from "react";
import "./QueryEngagement.css";
import axios from "../../axios";
import { useSelector } from "react-redux";
import moment from "moment";
import { IP } from "../../internalServer";
import { Link, NavLink } from "react-router-dom";
import { Item } from "semantic-ui-react";
import "intro.js/introjs.css";
import { Steps } from "intro.js-react";
import QueryTour from "../../SidebarHeader/Header/QueryTour";
import { queryHomeSteps } from "../../utils/querySteps";
import assets from "../../assets/assets";
import SingleGroup from "./SingleGroup";

export default function QueryEngagement() {
  const [isLoading, setIsLoading] = useState(false);
  const currentUser = useSelector((state) => state.user.currentUser);
  const [queryEngg, setQueryEngg] = useState({
    queryDetail: false,
  });

  const handleCloseQueryDetails = () => {
    setQueryEngg({
      ...queryEngg,
      queryDetail: false,
    });
  };
  const [groups, setGroups] = useState([]);

  useEffect(() => {
    const getGroups = async () => {
      setIsLoading(true)
      try {
        let res = await axios.get(
          `/group/filterForStudent/studentId/${currentUser?.id}?standardId=${currentUser?.standard?.id}&sectionId=${currentUser?.section?.id}&_page=1&_limit=20`
        );
        res && setGroups(res.data.data);
        setIsLoading(false)
      } catch (error) {
        console.log(error);
        setIsLoading(false)
      }
    };

    getGroups();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [stepsEnabled, setStepsEnabled] = useState(false);
  const [initialStep, setInitialStep] = useState(0);
  const [homeScreenWalkThroughPopup, setHomeScreenWalkThroughPopup] =
    useState(false);
  useEffect(() => {
    // Check if the popup has been shown before
    const hasShownPopup = localStorage.getItem("hasShownPopupQuery");
    if (!hasShownPopup) {
      // Show the steps if it hasn't been shown before
      setHomeScreenWalkThroughPopup(true);
      // Set the flag in localStorage to indicate the popup has been shown
      localStorage.setItem("hasShownPopupQuery", "true");
    }
  }, []);
  const [steps, setSteps] = useState(queryHomeSteps);
  const onExit = () => {
    setStepsEnabled(false);
  };

  const timeHelper = (a) => {
    const dateObj = new Date(a);
    // Adjust for IST (UTC+5:30)
    dateObj.setUTCHours(dateObj.getUTCHours() + 5);
    dateObj.setUTCMinutes(dateObj.getUTCMinutes() + 30);

    const day = dateObj.getUTCDate();
    const month = dateObj.getUTCMonth() + 1;
    const year = dateObj.getUTCFullYear();
    let hours = dateObj.getUTCHours();
    const minutes = dateObj.getUTCMinutes();
    const seconds = dateObj.getUTCSeconds();

    let meridiem = "AM";
    if (hours >= 12) {
      meridiem = "PM";
      hours -= 12;
    }
    if (hours === 0) {
      hours = 12;
    }

    const outputDateString = `${year}-${month}-${day}`;
    const outputTimeString = `${hours}:${minutes}:${seconds} ${meridiem}`;
    const outputDateTimeString = `${outputDateString} ${outputTimeString}`;
    return outputDateTimeString;
  };

  return (
    <>
      <Steps
        enabled={stepsEnabled}
        steps={steps}
        initialStep={initialStep}
        onExit={onExit}
      />
      {/* {!queryEngg.queryDetail && */}
      <div style={{ width: "100%" }} className="totalQueryEngagement">
        <div className="poppins-semibold ms-5 text-[20px]">Groups</div>
        <hr
          style={{
            width: "100%",
            borderBottom: "2px solid #668598",
          }}
        />
        <div
          className="orange-scrollBar d-flex flex-column align-items-center"
          style={{
            maxHeight: "450px",
            width: "100%",
            overflowY: "scroll",
            paddingTop: "1em",
            paddingBottom: "1em",
          }}
        >
          {isLoading ? (
            <div className="d-flex justify-content-center align-items-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : groups && groups.length > 0 ? (
            groups.map((item) => <SingleGroup key={item.id} group={item} />)
          ) : (
            <div className="d-flex justify-content-center align-items-center py-5">
              <span className="poppins-semibold fs-5 ms-5 text-danger">
                No Groups Found
              </span>
            </div>
          )}
        </div>
        {/* <table style={{ borderCollapse: "collapse" }} className="tableQuery">
          <thead>
            <tr>
              <th style={{ width: "50%" }}>Groups</th>
              <th className="hederTable ">Class</th>
              <th className="hederTable">Section</th>
              <th className="hederTable">Subject</th>
              <th className="hederTable ">
                <div style={{ width: "100%" }}>Last Updated</div>
              </th>
            </tr>
          </thead>
          <tbody className="mt-4 queryGroups">
            {groups?.length >= 0 &&
              groups
                .filter((Item) => Item.type === "Query")
                .map((group, index) => (
                  <tr
                    key={index}
                    className="OnsectionOfTablDetail"
                    style={{ borderBottom: "1px solid #E5EBEE" }}
                    onClick={(e) =>
                      setQueryEngg({ ...queryEngg, queryDetail: group })
                    }
                  >
                    <NavLink className="link" to={`/groupWiseQuery`} state={{ groupId: group?.id }}>
                      <td>
                        <div
                          style={{ paddingTop: "10px" }}
                          className="d-flex gap-2 align-items-center"
                        >
                          <div>
                            <img
                              className="group_profile_img"
                              src={
                                group?.profile_picture
                                  ? IP +
                                  group?.profile_picture.replace(/^\./, "")
                                  : assets?.QueryImg
                              }
                              alt=""
                              onError={(e) => {
                                e.target.src = assets?.QueryImg
                              }}
                            ></img>
                          </div>
                          <div className="latest_query">
                            <div className="GroupNameQuery">{group?.name}</div>
                            <div className="GroupQueryDetail">
                              {group?.latest_query?.user?.name}:{" "}
                              {group?.latest_query?.query}
                            </div>
                          </div>
                        </div>
                      </td>
                    </NavLink>
                    <td className="detailsAllTable">
                      Class {group?.standard?.name}
                    </td>
                    <td className="detailsAllTable">
                      Section {group?.section?.name}
                    </td>
                    <td className="detailsAllTable">{group?.subject?.name}</td>
                    <td className="detailsAllTable">
                      {group?.latest_query?.user?.created_at
                        ? moment(
                          timeHelper(group?.latest_query?.user?.created_at)
                        ).calendar({
                          sameDay: "h:mm a",
                          lastDay: "[Yesterday]",
                          lastWeek: "DD MMM YYYY ",
                          sameElse: "DD MMM YYYY",
                        })
                        : "-"}
                    </td>
                  </tr>
                ))}
          </tbody>
        </table> */}
      </div>
      {homeScreenWalkThroughPopup && (
        <QueryTour
          setHomeScreenWalkThroughPopup={setHomeScreenWalkThroughPopup}
          setStepsEnabled={setStepsEnabled}
        />
      )}
    </>
  );
}
